export const RENTER_INVITE_QUERY_PARAM = 'renter-invite';
